import { render, staticRenderFns } from "./payPhase.vue?vue&type=template&id=531d2da0&scoped=true&"
import script from "./payPhase.vue?vue&type=script&lang=js&"
export * from "./payPhase.vue?vue&type=script&lang=js&"
import style0 from "./payPhase.vue?vue&type=style&index=0&id=531d2da0&scoped=true&lang=css&"
import style1 from "./payPhase.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d2da0",
  null
  
)

export default component.exports